import React from 'react';

import { Button, useTranslation } from '@testsigma/atoms';

interface ViewDetailsFormActionsProps {
  handleClose(event: React.SyntheticEvent): void;
  handleEdit(event: React.SyntheticEvent): void;
  handleDelete(event: React.SyntheticEvent): void;
}

const ViewDetailsFormActions: React.FC<ViewDetailsFormActionsProps> = (
  props: ViewDetailsFormActionsProps,
) => {
  const { handleClose, handleEdit, handleDelete } = props;

  const { t } = useTranslation();

  return (
    <div className='flex px-4 py-3 justify-between'>
      <Button type='secondary' onClick={handleClose}>
        {t('common.close')}
      </Button>
      <div>
        <Button type='danger-light' onClick={handleDelete}>
          {t('delete.connection.label')}
        </Button>

        <Button type='secondary' className='ml-4' onClick={handleEdit}>
          {t('edit.connection.label')}
        </Button>
      </div>
    </div>
  );
};

export { ViewDetailsFormActions };
